import React from 'react';
import { createPortal } from 'react-dom';

// Renders a modal's scrim + card at the end of <body>, escaping whatever
// stacking context the screen it was written in happens to sit in.
//
// Why this is not optional. A `position: fixed` overlay only covers the viewport
// if no ancestor has established a containing block for it, and its z-index only
// competes globally if no ancestor has established a stacking context. Both are
// created by things that look completely harmless:
//
//   - `transform` (including a translate in an entry animation)
//   - `opacity` under 1 — and an animation on opacity with `fill-mode: both`
//     keeps that context alive after the animation has visibly finished
//   - `filter`, `backdrop-filter`, `will-change`, `contain`
//
// Every dashboard screen wraps itself in an entrance animation, so every inline
// modal inherits one. The symptom is specific and easy to misread: the modal
// renders and works, but the sticky page header stays bright and clickable above
// the dim — because the scrim's z-index: 2100 is being resolved INSIDE the
// screen's context, and that whole context paints below the positioned header.
//
// Portaling to <body> sidesteps both rules. ConfirmDialog and BrandedLoader
// already do this; this component is the shared version for screens whose modals
// were written inline.
export const ModalPortal: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => createPortal(<>{children}</>, document.body);
